import { render } from "./MpidDetailsPage.vue?vue&type=template&id=5778b3e6&scoped=true"
import script from "./MpidDetailsPage.vue?vue&type=script&lang=js"
export * from "./MpidDetailsPage.vue?vue&type=script&lang=js"

import "./MpidDetailsPage.vue?vue&type=style&index=0&id=5778b3e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5778b3e6"]])

export default __exports__